import React from 'react';
import { ALL_PAGES } from '../../data/nav';
import type { MarketingPage } from '../../data/nav';
import { usePageMeta } from './PageMeta';

/** Thin binding so MarketingSite stays declarative: look the page's meta up
 *  by id and apply it to the document head. */
export function PageMetaBinding({ page }: { page: MarketingPage }) {
  usePageMeta(ALL_PAGES.find((p) => p.page === page));
  return null;
}

export default PageMetaBinding;
